































































































































































import { Component, Vue } from "vue-property-decorator";

import util from "../lib/util";
@Component({})



export default class TopBarMenu extends Vue {
  email: string = "";
  editionName: string = "";
  

  data() {
    return {
      menu: false,
    };
  }

  async created() {
    await this.$store.dispatch({
      type: 'session/init',
    });

    this.email=localStorage.getItem('userEmail');
    this.editionName=localStorage.getItem('packageName');


  }

  logout() {
    this.$store.commit("app/logout", this);
    util.abp.auth.clearToken();
    location.reload();
  }
}
